import React, { Fragment, useCallback, useEffect, useState } from 'react';

import moment from 'moment-timezone';




import logoImage from '../../../images/three-sixty-image/AvanadeLogo.png';
import { Ws360Wheel } from '../components/360Wheel/360Wheel';
import { threeSixtyData } from '../components/360Wheel/ThreeSixtyData';
import { WsThreeSixtyWheel } from "../components/DynamicThreeSixtyWheel/DynamicThreeSixtyWheel";


import { WsWheelItem, WsWheelRecharts } from "./WheelRecharts";
import { NavLink, Route, Switch, useHistory, useLocation, useParams } from "react-router-dom";
import { ActionButton, BaseButton, Breadcrumb, Button, DefaultButton, Dialog, DialogFooter, DialogType, Dropdown, DropdownMenuItemType, IBreadcrumbItem, Icon, IconButton, IDropdownOption, PrimaryButton, SearchBox, Shimmer, TextField } from "office-ui-fabric-react";
import { getBoardMetrics, WsScoreDashboard, WsServiceDashboard, WsTriage } from "./ScoreDashboard";



import { WsDecodeBoardInterface, WsDecodeData, WsDecodeSource, WsDecodeProfile, WsDecodeTable, WsDecodeMetric, WsDecodeField, WsDecodeAction } from '../../../../../core/src/interfaces';






import { Loading } from "../../Shared";
import { apiGet, apiPost } from "../../../helpers-sales";



import { WsDecodeSearchBox } from "./DecodePage";
import { WsDecodeClassification, WsSalesOrganizationType } from "../../../enums";


import './DecodeMetrics.scss';
import { generateDataValueList, getDataValueListFromDataList, getLabelList } from "./decode-data";
import { WsTimestamp } from "../../DateTime/Timestamp";
import { WsNumberField } from "../../Controls/Form/NumberField";













const filterTableList = (tableList: WsDecodeTable[], search: string) => {

  if (search) {

    if (search.length > 2) {

      const tableListFiltered: WsDecodeTable[] = [];

      tableList.forEach((tableItem) => {

        tableItem.fields.forEach((fieldItem) => {

          if (fieldItem.name.toLowerCase().indexOf(search.toLowerCase()) > -1) {

            const tableItemFind = tableListFiltered.find((item) => item.name === tableItem.name);

            if (tableItemFind) {

              tableItemFind.fields.push(fieldItem);

            } else {

              const t: WsDecodeTable = {
                name: tableItem.name,
                fields: [ fieldItem ]
              }

              tableListFiltered.push(t);
            }
          }

        });

      });

      return tableListFiltered;

    } else {
      return [];
    }

  } else {
    return tableList;
  }
};





const findField = (tableList: WsDecodeTable[], fieldId: string): WsDecodeField | undefined => {
  let field: WsDecodeField | undefined = undefined;

  tableList.forEach((tableItem: WsDecodeTable) => {

    const f = tableItem.fields.find((fieldItem) => fieldItem.id === fieldId);

    if (f) {
      field = f;
    }
  });

  return field;
};








type WsDecodeFieldBrowserProps = {
  tableList:        WsDecodeTable[];
  selectedField:    WsDecodeField | undefined;
  setSelectedField: (dataTable: string, dataField: string, dataType: string) => void;
  search:           string;
};

const WsDecodeFieldBrowser = (props: WsDecodeFieldBrowserProps) => {

  const [ expandedIds, setExpandedIds ] = useState<string[]>([]);

  const tableListFiltered = filterTableList(props.tableList, props.search);



  const labelList = getLabelList();

  // console.log(labelList);



  return (
    <div className="ws-decode-table-browser ws-scroll ws-scroll-y">
      <table className="table is-hoverable is-fullwidth">
        <thead>
          <tr>
            {/* <th style={{ width: '30px' }}></th> */}
            <th></th>
            <th>Type</th>
            <th>Source</th>
            <th>Entity</th>
          </tr>
        </thead>
        <tbody>
          {
            tableListFiltered
            .sort((a, b) => {  
              if (a.name.toLowerCase() > b.name.toLowerCase()) return  1;
              if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
              return 0;
            })
            .map((tableItem, tableIndex) => {

              const isExpanded = props.search.length > 2 ? true : expandedIds.includes(tableItem.name);

              const tableLabelItem = labelList.find((item) => item.table === tableItem.name);

              return (
                <Fragment key={`ws-decode-table-item-${tableIndex}`}>
                  <tr
                    className="ws-decode-table-item"
                    onClick={() => {
                      console.log('table click!');

                      if (isExpanded) {
                        const nextExpandedIds = [ ...expandedIds.filter(item => item !== tableItem.name) ];
                        setExpandedIds(nextExpandedIds);
                      } else {
                        const nextExpandedIds = [ ...expandedIds ];
                        nextExpandedIds.push(tableItem.name);
                        setExpandedIds(nextExpandedIds);
                      }
                    }}
                  >
                    <td>
                      {
                        isExpanded
                        ?
                        <>
                          <Icon iconName={'CollapseContentSingle'} className="ws-decode-collapsed" style={{ verticalAlign: 'top' }} /> <b>{tableItem.name}</b>
                        </>
                        :
                        <>                          
                          <Icon iconName={'ExploreContentSingle'} className="ws-decode-expanded" style={{ verticalAlign: 'top' }} /> {tableItem.name}
                        </>
                      }
                    </td>
                    <td>Table</td>
                    <td>{tableLabelItem?.source || 'DECODE'}</td>
                    <td>{tableLabelItem?.entity || '-'     }</td>
                  </tr>
                  {
                    isExpanded
                    &&
                    <>
                      {
                        tableItem.fields
                        .sort((a, b) => {  
                          if (a.name.toLowerCase() > b.name.toLowerCase()) return  1;
                          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                          return 0;
                        })
                        .map((fieldItem, fieldIndex) => {

                          const fieldId = `${tableItem.name}.${fieldItem.name}`;

                          const fieldLabelItem = labelList.find((item) => item.table === fieldItem.table && item.field === fieldItem.name);

                          return (
                            <tr
                              key={`ws-decode-field-item-${fieldIndex}`}
                              className={ props.selectedField?.id === fieldId ? 'ws-decode-field-item ws-decode-field-item-selected' : 'ws-decode-field-item'}
                              onClick={() => {
                                props.setSelectedField(tableItem.name, fieldItem.name, fieldItem.type);
                              }}
                            >
                              <td style={{ paddingLeft: '28px' }}>{fieldItem.name}</td>
                              <td>{fieldItem.type}</td>
                              <td>{fieldLabelItem?.source || 'DECODE'}</td>
                              <td>{fieldLabelItem?.entity || '-'     }</td>
                            </tr>
                          );
                        })
                      }
                    </>
                  }
                </Fragment>
              );
            })
          }
        </tbody>
      </table>
    </div>
  );
};






type WsDecodeFieldFinderProps = {
  // tableList:        WsDecodeTable[];
  // selectedField:    WsDecodeField | undefined;
  selectedFieldId: string;
  setSelectedField: (dataTable: string, dataField: string, dataType: string) => void;
};

const WsDecodeFieldFinder = (props: WsDecodeFieldFinderProps) => {

  const [ search, setSearch ] = useState<string>('');



  const [ tableList, setTableList ] = useState<WsDecodeTable[] | undefined>(undefined);

  const loadData = useCallback(async () => {

    const result = await apiGet(`/decode/table-list`);

    if (result && Array.isArray(result.tableList)) {
      const resultData = result.tableList as WsDecodeTable[];
      // console.log(resultData);
      setTableList(resultData);
    }

  }, []);

  useEffect(() => {
    loadData();
  }, []);



  if (tableList) {

    const selectedField = findField(tableList, props.selectedFieldId);

    return (
      <div className="ws-decode-source-finder">

        <WsDecodeSearchBox
          setSearch={(searchValue: string) => {
            setSearch(searchValue);
          }}
        />

        {
          search
          &&
          search.length < 3
          &&
          <div className="ws-decode-source-finder-search-hint"><Icon iconName="Warning" />Please use at least 3 characters to search!</div>
        }

        <WsDecodeFieldBrowser
          tableList={tableList}
          selectedField={selectedField}
          setSelectedField={props.setSelectedField}
          search={search}
        />

        <br />

        <div className="columns">
          <div className="column is-1">
            <b>Field:</b>
          </div>
          <div className="column is-3">
            {selectedField?.name || '-'}
          </div>

          <div className="column is-1">
            <b>Type:</b>
          </div>
          <div className="column is-2">
            {selectedField?.type || '-'}
          </div>

          <div className="column is-1">
            <b>Table:</b>
          </div>
          <div className="column is-4">
            {selectedField?.table || '-'}
          </div>
        </div>
      </div>
    );

  } else {
    return (
      <Loading />
    );
  }
};







type WsDecodeSourceFormProps = {
  source:    WsDecodeSource;
  setSource: React.Dispatch<React.SetStateAction<WsDecodeSource>>;
};

const WsDecodeSourceForm = (props: WsDecodeSourceFormProps) => {

  return (
    <div className="ws-decode-source-form">
      <>
        {
          props.source.id
          ?
          <>
            {/* edit existing */}
          </>
          :
          <>
            {/* new */}
            <WsDecodeFieldFinder
              selectedFieldId={`${props.source.dataTable}.${props.source.dataField}`}
              setSelectedField={(dataTable: string, dataField: string, dataType: string) => {
                const nextSource = { ...props.source };

                nextSource.dataSource = 'DECODE';
                nextSource.dataTable  = dataTable;
                nextSource.dataField  = dataField;
                nextSource.dataType   = dataType;

                props.setSource(nextSource);
              }}
            />
            <br />
            <br />
          </>
        }

        <div className="columns">
          <div className="column is-1" style={{ paddingTop: '17px' }}>
            <b>Name:</b>
          </div>
          <div className="column">
            <TextField
              // label="Name"
              placeholder="Name"
              onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                const nextSource = { ...props.source };

                nextSource.name = newValue || '';

                nextSource.dataValueList = []; // generateDataValueList();

                props.setSource(nextSource);
              }}
              value={props.source.name}
            />
          </div>
        </div>
      </>
    </div>
  );
};





type WsDecodeSourceDialogProps = {
  source:    WsDecodeSource;
  onCancel: () => void;
  onSave:   (source: WsDecodeSource) => Promise<void>;
};

const WsDecodeSourceDialog = (props: WsDecodeSourceDialogProps) => {

  const [ source, setSource ] = useState<WsDecodeSource>({ ...props.source });

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.onCancel();
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.onCancel();
  };

  const onClickSave = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.onSave(source);
  };

  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        title: source.id ? `Edit Metric` : `Add Metric`,
        type: DialogType.normal
      }}
      modalProps={{
        className: 'ws-decode-label-dialog',
        isBlocking: false,
        styles: {
          // main: { width: 700 }
        }
      }}
    >
      <Fragment>
        <div className="ws-decode-label-form">

          <WsDecodeSourceForm
            source={source}
            setSource={setSource}
          />

          <br />
        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} disabled={(source.name && source.dataSource && source.dataTable && source.dataField) ? false : true} />
        </>
      </DialogFooter>
    </Dialog>
  );
};







const WsDecodeAdminMetrics = (props: {}) => {

  const [ dialogSource, setDialogSource ] = useState<WsDecodeSource | undefined>(undefined);

  const [ sourceList, setSourceList ] = useState<WsDecodeSource[] | undefined>(undefined);

  const loadData = useCallback(async () => {

    const result = await apiGet(`/decode/source-list`);

    if (result && Array.isArray(result.sourceList)) {
      const resultData = result.sourceList as WsDecodeSource[];
      // console.log(resultData);
      setSourceList(resultData.filter((item) => !item.deletedAt));
    }

  }, []);

  useEffect(() => {
    loadData();
  }, []);

  if (sourceList) {

    return (
      <div className="ws-decode-admin-labels">
        <br />

        <ActionButton
          className="ws-decode-admin-add-label"
          iconProps={{
            iconName: 'CircleAddition'
          }}
          onClick={async () => {
            const newSourceItem: WsDecodeSource = {
              id:             '',
              name:           '',
              dataSource:     '',
              dataTable:      '',
              dataField:      '',
              dataType:       '',
              dataValue:      0,
              dataValueList:  [], // generateDataValueList(),
              classification: WsDecodeClassification.None
            }
            setDialogSource(newSourceItem);
          }}
        >
          Add Metric
        </ActionButton>

        <br />

        <table className="table is-hoverable is-fullwidth ws-decode-admin-metric-table">
          <thead>
            <tr>
              <th>Metric</th>
              <th>Type</th>
              <th>Field</th>
              <th>Table</th>
              <th>Classification</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {
              sourceList
              .sort((a, b) => {  
                if (a.name.toLowerCase() > b.name.toLowerCase()) return  1;
                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                return 0;
              })
              .map((sourceItem, index) => {
                return (
                  <tr key={`ws-decode-label-item-${index}`}>
                    <td>{sourceItem.name}</td>
                    <td>{sourceItem.dataType}</td>
                    <td>{sourceItem.dataField}</td>
                    <td>{sourceItem.dataTable}</td>
                    <td>{sourceItem.classification}</td>
                    <td className="ws-decode-admin-metric-table-action">
                      <ActionButton
                        // className="ws-decode-edit-board"
                        iconProps={{
                          iconName: 'PageEdit'
                        }}
                        onClick={async () => {
                          setDialogSource(sourceItem);
                        }}
                      />
                      <ActionButton
                        // className="ws-decode-edit-board"
                        iconProps={{
                          iconName: 'Delete'
                        }}
                        onClick={async () => {
                          if (window.confirm(`Delete "${sourceItem.name}"?`)) {

                            const nextSourceItem = { ...sourceItem };

                            nextSourceItem.deletedAt = (new Date()).toISOString();

                            const deleteSourceItem = await apiPost(`/decode/source-list`, { ...nextSourceItem });

                            if (deleteSourceItem && deleteSourceItem.sourceItem) {
                              console.log(deleteSourceItem.sourceItem);
                            }

                            setSourceList(undefined);

                            loadData();
                          }
                        }}
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>

        {
          dialogSource
          &&
          <WsDecodeSourceDialog
            source={dialogSource}
            onCancel={() => {
              setDialogSource(undefined);
            }}
            onSave={async (source: WsDecodeSource) => {

              const createSourceItem = await apiPost(`/decode/source-list`, { ...source });

              if (createSourceItem && createSourceItem.sourceItem) {
                console.log(createSourceItem.sourceItem);
              }

              setSourceList(undefined);

              await loadData();

              setDialogSource(undefined);
            }}
          />
        }
      </div>
    );

  } else {
    return (<Loading />);
  }
};













type WsDecodeMetricListProps = {
  boardList: WsDecodeBoardInterface[] | undefined;
};

const WsDecodeMetricList = (props: WsDecodeMetricListProps) => {

  const params: { boardId?: string, metricId?: string } = useParams();





  const [ sourceList, setSourceList ] = useState<WsDecodeSource[] | undefined>(undefined);

  const loadSourceData = useCallback(async () => {

    const result = await apiGet(`/decode/source-list`);

    if (result && Array.isArray(result.sourceList)) {
      const resultData = result.sourceList as WsDecodeSource[];
      // console.log(resultData);
      setSourceList(resultData);
    }

  }, []);

  useEffect(() => {
    loadSourceData();
  }, []);






  const [ dataList, setDataList ] = useState<WsDecodeData[] | undefined>(undefined);

  const loadDataList = useCallback(async () => {

    const result = await apiGet(`/decode/data-list`);

    if (result && Array.isArray(result.dataList)) {
      const resultData = result.dataList as WsDecodeData[];
      // console.log(resultData);
      setDataList(resultData);
    }

  }, []);

  useEffect(() => {
    loadDataList();
  }, []);





  if (props.boardList && sourceList && dataList) {



    const boardItem = props.boardList?.find((item) => `${item.id}` === params.boardId);

    const metricItem = boardItem ? getBoardMetrics(boardItem).find((item) => `${item.id}`.toLowerCase() === `${params.metricId}`.toLowerCase()) : undefined;

    if (metricItem) {
      console.log(metricItem.sourceId);

      const sourceItem = sourceList.find((item) => item.id === metricItem.sourceId);

      console.log(sourceItem);



      return (
        <div className="ws-deliver-decode-metrics">
          <br />
          <table className="table is-hoverable is-fullwidth">
            <thead>
              <tr>
                <th>Data Values</th>
              </tr>
            </thead>
            <tbody>
              {
                sourceItem
                ?
                <>
                  {
                    getDataValueListFromDataList(dataList, sourceItem.dataTable, sourceItem.dataField).map((dataValue, index) => {
                      return (
                        <tr key={`ws-decode-data-value-${index}`}>
                          <td>{`${dataValue}` || '(blank value)'}</td>
                        </tr>
                      );
                    })
                  }
                </>
                :
                <>No Data!</>
              }
            </tbody>
          </table>
        </div>
      );

    } else {
      return (<Loading />);
    }

  } else {
    return (<Loading />);
  }
};











const getBoardMetricList = (boardList: WsDecodeBoardInterface[]) => {
  const metricList: { board: WsDecodeBoardInterface, metric: WsDecodeMetric }[] = [];

  boardList.forEach((boardItem) => {

    if (boardItem.configuration.metrics && Array.isArray(boardItem.configuration.metrics)) {

      (boardItem.configuration.metrics as WsDecodeMetric[]).forEach((metricItem) => {

        metricList.push({
          board:  boardItem,
          metric: metricItem
        });
      });
    }
  });

  return metricList;
};




const getBoardMetricOptions = (boardList: WsDecodeBoardInterface[]) => {
  const options: IDropdownOption[] = [];

  boardList
  .sort((a, b) => {  
    if (a.name.toLowerCase() > b.name.toLowerCase()) return  1;
    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
    return 0;
  })
  .forEach((boardItem) => {

    if (boardItem.configuration.metrics && Array.isArray(boardItem.configuration.metrics)) {

      const metricList = boardItem.configuration.metrics as WsDecodeMetric[];

      if (metricList.length > 0) {

        options.push({ key: `${boardItem.id}`, text: boardItem.name, itemType: DropdownMenuItemType.Header });

        metricList
        .sort((a, b) => {  
          if (a.name.toLowerCase() > b.name.toLowerCase()) return  1;
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          return 0;
        })
        .forEach((metricItem) => {

          options.push({
            key:  metricItem.id,
            text: metricItem.name
          });
        });
      }
    }
  });

  return options;
};




const actionTypes = {
  'EMAIL':      'Send E-mail',
  'SCRIPT':     'Run Script',
  'SERVICENOW': 'Create ServiceNow Ticket'
};




type WsDecodeActionDialogProps = {
  action:   WsDecodeAction;
  onCancel: () => void;
  onSave:   (action: WsDecodeAction) => Promise<void>;
};

const WsDecodeActionDialog = (props: WsDecodeActionDialogProps) => {

  const [ action, setAction ] = useState<WsDecodeAction>({ ...props.action });

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.onCancel();
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.onCancel();
  };

  const onClickSave = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.onSave(action);
  };



  const [ boardList, setBoardList ] = useState<WsDecodeBoardInterface[] | undefined>(undefined);

  const loadBoards = useCallback(async () => {

    const result = await apiGet(`/decode/boards`);

    if (result && Array.isArray(result.decodeBoardList)) {
      const resultData = result.decodeBoardList as WsDecodeBoardInterface[];
      // console.log(resultData);
      setBoardList(resultData);
    }

  }, []);

  useEffect(() => {
    loadBoards();
  }, []);



  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        title: action.id ? `Edit Action` : `Add Action`,
        type: DialogType.normal
      }}
      modalProps={{
        className: 'ws-decode-label-dialog',
        isBlocking: false,
        styles: {
          // main: { width: 700 }
        }
      }}
    >
      {
        boardList
        ?
        <>
      <Fragment>
        <div className="ws-decode-label-form">

          <div className="columns">
            <div className="column is-2" style={{ paddingTop: '17px' }}>
              <b>When (Metric):</b>
            </div>
            <div className="column">
              <Dropdown
                // label={`When:`}
                options={getBoardMetricOptions(boardList)}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {

                    const nextAction = { ...action };

                    nextAction.metricId = `${option.key}`;

                    setAction(nextAction);
                  }
                }}
                placeholder="Select Metric"
                selectedKey={action.metricId}
              />
            </div>
          </div>

          <div className="columns">
            <div className="column is-2" style={{ paddingTop: '17px' }}>
              <b>Meets (Value):</b>
            </div>
            <div className="column">
              <WsNumberField
                className="ws-input-number input is-normal"
                organization={WsSalesOrganizationType.Avanade}
                min={0}
                max={100}
                size={4}
                precision={0}
                onChange={(value: number | null, stringValue: string, input: HTMLInputElement) => {
                  const nextAction = { ...action };

                  if (value !== null && !isNaN(value)) {
                    if (value < 0) {
                      nextAction.value = 0;
                    } else if (value > 9999) {
                      nextAction.value = 9999;
                    } else {
                      nextAction.value = value;
                    }
                  } else {
                    nextAction.value = 0;
                  }

                  setAction(nextAction);
                }}
                value={(action.value || action.value === 0) ? action.value : 9999}
              />
            </div>
          </div>

          <div className="columns">
            <div className="column is-2" style={{ paddingTop: '17px' }}>
              <b>Run Action:</b>
            </div>
            <div className="column">
              <Dropdown
                // label={`When:`}
                options={[
                  { key: 'EMAIL',      text: 'Send E-Mail'              },
                  { key: 'SCRIPT',     text: 'Run Script'               },
                  { key: 'SERVICENOW', text: 'Create ServiceNow Ticket' }
                ]}
                onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
                  if (option) {

                    const nextAction = { ...action };

                    nextAction.type = `${option.key}`;

                    setAction(nextAction);
                  }
                }}
                placeholder="Select Type"
                selectedKey={action.type}
              />
            </div>
          </div>

          <div className="columns">
            <div className="column is-2" style={{ paddingTop: '17px' }}>
              <b>Action Name:</b>
            </div>
            <div className="column">
              <TextField
                // label="Name"
                placeholder="Name"
                onChange={(event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string | undefined) => {
                  const nextAction = { ...action };

                  if (newValue) {
                    nextAction.name = newValue;
                  } else {
                    nextAction.name = '';
                  }

                  setAction(nextAction);
                }}
                value={action.name}
              />
            </div>
          </div>

          <br />
        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickSave}   text="Save" style={{ marginLeft: '4px' }} disabled={ (action.metricId && action.type && action.name) ? false : true } />
        </>
      </DialogFooter>
      </>
        :
        <>
          <Loading />
          <br />
          <br />
          <br />
        </>
      }
    </Dialog>
  );
};











const WsDecodeAdminActions = (props: {}) => {

  const [ dialogAction, setDialogAction ] = useState<WsDecodeAction | undefined>(undefined);



  const [ boardList, setBoardList ] = useState<WsDecodeBoardInterface[] | undefined>(undefined);

  const loadBoards = useCallback(async () => {

    const result = await apiGet(`/decode/boards`);

    if (result && Array.isArray(result.decodeBoardList)) {
      const resultData = result.decodeBoardList as WsDecodeBoardInterface[];
      // console.log(resultData);
      setBoardList(resultData);
    }

  }, []);

  useEffect(() => {
    loadBoards();
  }, []);



  const [ actionList, setActionList ] = useState<WsDecodeAction[] | undefined>(undefined);

  const loadData = useCallback(async () => {

    const result = await apiGet(`/decode/action-list`);

    if (result && Array.isArray(result.actionList)) {
      const resultData = result.actionList as WsDecodeAction[];
      // console.log(resultData);
      setActionList(resultData.filter((item) => !item.deletedAt));
    }

  }, []);

  useEffect(() => {
    loadData();
  }, []);



  if (boardList && actionList) {

    return (
      <div className="ws-decode-admin-labels">
        <br />

        <ActionButton
          className="ws-decode-admin-add-label"
          iconProps={{
            iconName: 'CircleAddition'
          }}
          onClick={async () => {
            const newActionItem: WsDecodeAction = {
              id:           '',
              name:         '',
              metricId:     '',

              type:         'EMAIL',
              condition:    '',
              value:        0,

              modifiedAt:     new Date().toISOString(),
              usedAt:         new Date().toISOString()
            }
            setDialogAction(newActionItem);
          }}
        >
          Add Action
        </ActionButton>

        <table className="table is-hoverable is-fullwidth ws-decode-admin-metric-table ws-decode-admin-action-table">
          <thead>
            <tr>
              <th>Action</th>
              <th>Type</th>
              <th>Resource</th>
              {/* <th>Used By</th> */}
              <th>Last Modified</th>
              <th>Last Used</th>
              <td></td>
            </tr>
          </thead>
          <tbody>
            {
              actionList
              .sort((a, b) => {  
                if (a.name.toLowerCase() > b.name.toLowerCase()) return  1;
                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                return 0;
              })
              .map((actionItem, index) => {

                const metricItem = getBoardMetricList(boardList).find((item) => item.metric.id === actionItem.metricId);

                return (
                  <tr key={`ws-decode-label-item-${index}`}>
                    <td>{actionItem.name}</td>
                    <td>{actionTypes[actionItem.type]}</td>
                    <td>{metricItem ? `${metricItem.board.name} - ${metricItem.metric.name}` : ''}</td>
                    {/* <td>0</td> */}
                    <td><WsTimestamp timestamp={new Date(actionItem.modifiedAt)} /></td>
                    <td><WsTimestamp timestamp={new Date(actionItem.usedAt)}     /></td>
                    <td className="ws-decode-admin-metric-table-action">
                      <ActionButton
                        // className="ws-decode-edit-board"
                        iconProps={{
                          iconName: 'PageEdit'
                        }}
                        onClick={async () => {
                          setDialogAction(actionItem);
                        }}
                      />
                      <ActionButton
                        // className="ws-decode-edit-board"
                        iconProps={{
                          iconName: 'Delete'
                        }}
                        onClick={async () => {
                          if (window.confirm(`Delete "${actionItem.name}"?`)) {

                            setActionList(undefined);

                            const nextActionItem = { ...actionItem };

                            nextActionItem.deletedAt = (new Date()).toISOString();

                            const deleteActionItem = await apiPost(`/decode/action-list`, { ...nextActionItem });

                            if (deleteActionItem && deleteActionItem.actionItem) {
                              console.log(deleteActionItem.actionItem);
                            }

                            loadData();
                          }
                        }}
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>

        {
          dialogAction
          &&
          <WsDecodeActionDialog
            action={dialogAction}
            onCancel={() => {
              setDialogAction(undefined);
            }}
            onSave={async (action: WsDecodeAction) => {

              setActionList(undefined);

              const a = { ...action };

              a.modifiedAt =    new Date().toISOString();
              a.usedAt     =    new Date().toISOString();

              const createActionItem = await apiPost(`/decode/action-list`, { ...a });

              if (createActionItem && createActionItem.actionItem) {
                console.log(createActionItem.actionItem);
              }

              await loadData();

              setDialogAction(undefined);
            }}
          />
        }
      </div>
    );

  } else {
    return (<Loading />);
  }
};









const WsDecodeLinkBoardDialog = (props: {
  boardList:   WsDecodeBoardInterface[];
  boardItem:   WsDecodeBoardInterface;
  onCancel: () => void;
  onSave:   (targetBoard: WsDecodeBoardInterface) => Promise<void>;
}) => {

  const [ targetBoard, setTargetBoard ] = useState<WsDecodeBoardInterface | undefined>(undefined);

  const onDismiss = (ev?: React.MouseEvent<HTMLButtonElement, MouseEvent> | undefined) => {
    props.onCancel();
  };

  const onClickCancel = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    props.onCancel();
  };

  const onClickSave = (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
    if (targetBoard) {
      props.onSave(targetBoard);
    }
  };

  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      dialogContentProps={{
        title: `Copy Board (${props.boardItem.name}) to`,
        type: DialogType.normal
      }}
      modalProps={{
        className: 'ws-decode-label-dialog',
        isBlocking: false,
        styles: {
          // main: { width: 700 }
        }
      }}
    >
      <Fragment>
        <div className="ws-decode-label-form">

        <Dropdown
            label={`Target`}
            options={
              props.boardList
              .sort((a, b) => {  
                if (a.name.toLowerCase() > b.name.toLowerCase()) return  1;
                if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                return 0;
              })
              .map((boardItem): IDropdownOption => {
                return { key: `${boardItem.id}`, text: boardItem.name };
              })
            }
            onChange={(event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption | undefined, index?: number | undefined): void => {
              if (option) {

                const boardItem = props.boardList.find((item) => item.id === Number(option.key));

                if (boardItem) {
                  setTargetBoard(boardItem);
                }
              }
            }}
            placeholder="Select Target"
            selectedKey={targetBoard ? `${targetBoard.id}` : ''}
          />

          <br />
        </div>
      </Fragment>
      <DialogFooter>
        <>
          <DefaultButton onClick={onClickCancel} text="Cancel" />
          <PrimaryButton onClick={onClickSave}   text="Copy" style={{ marginLeft: '4px' }} disabled={targetBoard ? false : true} />
        </>
      </DialogFooter>
    </Dialog>
  );
};








export {
  WsDecodeLinkBoardDialog,
  WsDecodeAdminActions,
  WsDecodeSourceDialog,
  WsDecodeAdminMetrics,
  WsDecodeMetricList,
  WsDecodeFieldFinder
};
